module.exports = __webpack_public_path__ + "img/instagramg.c4019986.svg";